import { getSettingByName } from "@/utils";

const Mixin = {
    data() {
        return {
            isHacker: false
        };
    },
    async created() {
        console.log("created mixins")
        this.isHacker = (await getSettingByName("hacker")) === true;
    }
};
export default Mixin;


// WEBPACK FOOTER //
// ./src/mixins.js